module.exports = __webpack_public_path__ + "media/images/pages/img_gourmet_03-b464b0f87afcfbc507721eabd9fa68da.jpg";